export const getAuthAttributes = (user: any): any | undefined => {
  let source = user?.attributes;

  if (!source) {
    if (user?.signInUserSession?.idToken?.payload) {
      source = user.signInUserSession.idToken.payload;
    }
  }

  return source;
}